"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const material_1 = require("@mui/material");
const lab_1 = require("@mui/lab");
const AdapterDateFns_1 = __importDefault(require("@mui/lab/AdapterDateFns"));
const LocalizationProvider_1 = __importDefault(require("@mui/lab/LocalizationProvider"));
const locale_1 = require("date-fns/locale");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const DatePickerLocales = {
    enUS: locale_1.enUS,
    de: locale_1.de,
    da: locale_1.da,
    es: locale_1.es,
    fi: locale_1.fi,
    fr: locale_1.fr,
    hr: locale_1.hr,
    it: locale_1.it,
    ja: locale_1.ja,
    nb: locale_1.nb,
    pt: locale_1.pt,
    ru: locale_1.ru,
    sv: locale_1.sv,
    tr: locale_1.tr,
};
const DateValidationError = styled_components_1.default.div `
  color: red;
  font-style: italic;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const DateAndTime = ({ fieldData, onChange, currentLocale, withPastDates = true }) => {
    const [selectedDate, setSelectedDate] = (0, react_1.useState)(fieldData.value ? fieldData.value : null);
    const datePickerLocale = DatePickerLocales[currentLocale] || DatePickerLocales.enUS;
    const handleDateChange = (newDate) => {
        if (newDate && newDate.toString() !== "Invalid Date") {
            setSelectedDate(newDate);
            onChange(fieldData, newDate);
        }
    };
    (0, react_1.useEffect)(() => {
        setSelectedDate(fieldData.value ? fieldData.value : null);
    }, [fieldData.value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: fieldData.errors && fieldData.errors.length > 0 ? "field-error" : "" },
            react_1.default.createElement(LocalizationProvider_1.default, { dateAdapter: AdapterDateFns_1.default, locale: datePickerLocale }, fieldData.type === "datetime" ? (react_1.default.createElement(lab_1.DateTimePicker, { renderInput: (params) => (react_1.default.createElement(material_1.TextField, Object.assign({ required: fieldData.mandatory, fullWidth: true }, params))), label: fieldData.label, value: selectedDate, ampm: false, onChange: handleDateChange, disabled: fieldData.disabled || false, className: "datetime-picker", disablePast: !withPastDates })) : (react_1.default.createElement(lab_1.DesktopDatePicker, { label: fieldData.label, value: selectedDate, onChange: handleDateChange, disabled: fieldData.disabled || false, className: "datetime-picker", renderInput: (params) => (react_1.default.createElement(material_1.TextField, Object.assign({ required: fieldData.mandatory, fullWidth: true }, params))), disablePast: !withPastDates })))),
        fieldData.errors && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(DateValidationError, null, fieldData.errors.map((error) => (react_1.default.createElement("div", { key: (0, react_uid_1.uid)(error) }, error))))))));
};
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(DateAndTime);
